/** @jsxImportSource @emotion/react */
import { ClassNames } from "@emotion/react";
import { Radio } from "@mui/material";
import FormControlLabel from "@mui/material/FormControlLabel";
import { forwardRef, JSX } from "react";

interface RadioButtonProps {
  value: string;
  label: string | React.ReactElement<any>;
  checked?: boolean;
  hideLabel?: boolean;
  disabled?: boolean;
  alignTop?: boolean;
}

export const RadioButton = forwardRef(
  (
    { value, label, checked, hideLabel, disabled, alignTop }: RadioButtonProps,
    ref
  ): JSX.Element => {
    return (
      <ClassNames>
        {({ css, theme }) => (
          <FormControlLabel
            ref={ref}
            value={value}
            control={
              <Radio
                checked={checked}
                classes={{
                  root: css`
                    &.Mui-checked {
                      color: ${theme.palette.primary.main};
                    }
                    stroke: white;
                    stroke-width: 0.5px;
                    &.Mui-disabled {
                      color: ${theme.palette.grey[400]};
                    }
                  `,
                }}
                color="primary"
                disabled={disabled}
              />
            }
            label={hideLabel ? null : label}
            css={css`
              /* 16px label text, not the app's 18px body1 */
              & .MuiFormControlLabel-label {
                font-size: 1rem;
                line-height: 1.5;
                letter-spacing: normal;
              }
              ${
                alignTop &&
                css`
                  align-items: flex-start;
                `
              }
            `}
          />
        )}
      </ClassNames>
    );
  }
);
